import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Admin pages
import Login from 'src/components/Dashboard/Views/Login.vue'
import Categories from 'src/components/Dashboard/Views/Categories.vue'
import CreateCategory from 'src/components/Dashboard/Views/Category/Create.vue'
import EditCategory from 'src/components/Dashboard/Views/Category/Edit.vue'
import Templates from 'src/components/Dashboard/Views/Templates.vue'
import CreateTemplate from 'src/components/Dashboard/Views/Template/Create.vue'
import EditTemplate from 'src/components/Dashboard/Views/Template/Edit.vue'
import Memories from 'src/components/Dashboard/Views/Memories.vue'
import CreateMemories from 'src/components/Dashboard/Views/Memories/Create.vue'
import EditMemories from 'src/components/Dashboard/Views/Memories/Edit.vue'
import Tags from 'src/components/Dashboard/Views/Tags.vue'
import CreateTag from 'src/components/Dashboard/Views/Tag/Create.vue'
import EditTag from 'src/components/Dashboard/Views/Tag/Edit.vue'
import Tabs from 'src/components/Dashboard/Views/Tabs.vue'
import CreateTab from 'src/components/Dashboard/Views/Tab/Create.vue'
import EditTab from 'src/components/Dashboard/Views/Tab/Edit.vue'
import Albums from 'src/components/Dashboard/Views/Albums.vue'
import CreateAlbum from 'src/components/Dashboard/Views/Albums/Create.vue'
import EditAlbum from 'src/components/Dashboard/Views/Albums/Edit.vue'
import Tracks from 'src/components/Dashboard/Views/Tracks.vue'
import CreateTrack from 'src/components/Dashboard/Views/Tracks/Create.vue'
import EditTrack from 'src/components/Dashboard/Views/Tracks/Edit.vue'
import Reports from 'src/components/Dashboard/Views/Reports.vue'
import CreateReport from 'src/components/Dashboard/Views/Reports/Create.vue'
import PreviewHub from 'src/components/Dashboard/Views/PreviewHub.vue'
import Preview from 'src/components/Dashboard/Views/Preview.vue'
import PostsPreview from 'src/components/Dashboard/Views/PostsPreview.vue'
import PostsPreviewNola from 'src/components/Dashboard/Views/PostsPreviewNola.vue'
import Icons from 'src/components/Dashboard/Views/Icons.vue'
import Logs from 'src/components/Dashboard/Views/Logs.vue'
import Finance from 'src/components/Dashboard/Views/Finance.vue'
import PushTask from 'src/components/Dashboard/Views/Push.vue'
import CreatePushTask from 'src/components/Dashboard/Views/Push/Create.vue'
import CreateFinance from 'src/components/Dashboard/Views/Finance/Create.vue'
import EditFinance from 'src/components/Dashboard/Views/Finance/Edit.vue'
import Calendar from 'src/components/Dashboard/Views/Calendar.vue'
import Fonts from 'src/components/Dashboard/Views/Fonts.vue'
import CreateFont from 'src/components/Dashboard/Views/Fonts/Create.vue'
import EditFont from 'src/components/Dashboard/Views/Fonts/Edit.vue'
import FontsCategories from 'src/components/Dashboard/Views/FontsCategories.vue'
import CreateFontsCategory from 'src/components/Dashboard/Views/FontsCategories/Create.vue'
import EditFontsCategory from 'src/components/Dashboard/Views/FontsCategories/Edit.vue'
import GraphicsCategories from 'src/components/Dashboard/Views/GraphicsCategories.vue'
import CreateGraphicsCategory from 'src/components/Dashboard/Views/GraphicsCategories/Create.vue'
import EditGraphicsCategory from 'src/components/Dashboard/Views/GraphicsCategories/Edit.vue'
import Graphics from 'src/components/Dashboard/Views/Graphics.vue'
import CreateGraphic from 'src/components/Dashboard/Views/Graphics/Create.vue'
import EditGraphic from 'src/components/Dashboard/Views/Graphics/Edit.vue'
import FramesCategories from 'src/components/Dashboard/Views/FramesCategories.vue'
import CreateFramesCategory from 'src/components/Dashboard/Views/FramesCategories/Create.vue'
import EditFramesCategory from 'src/components/Dashboard/Views/FramesCategories/Edit.vue'
import Frames from 'src/components/Dashboard/Views/Frames.vue'
import ResourcePreview from 'src/components/Dashboard/Views/ResourcePreview.vue'
import Calc from 'src/components/Dashboard/Views/Calc.vue'
import CreateFrame from 'src/components/Dashboard/Views/Frames/Create.vue'
import EditFrame from 'src/components/Dashboard/Views/Frames/Edit.vue'
import EffectsCategories from 'src/components/Dashboard/Views/EffectsCategories.vue'
import CreateEffectsCategory from 'src/components/Dashboard/Views/EffectsCategories/Create.vue'
import EditEffectsCategory from 'src/components/Dashboard/Views/EffectsCategories/Edit.vue'
import Effects from 'src/components/Dashboard/Views/Effects.vue'
import CreateEffect from 'src/components/Dashboard/Views/Effects/Create.vue'
import EditEffect from 'src/components/Dashboard/Views/Effects/Edit.vue'
import MusicCategories from 'src/components/Dashboard/Views/MusicCategories.vue'
import CreateMusicCategory from 'src/components/Dashboard/Views/MusicCategories/Create.vue'
import EditMusicCategory from 'src/components/Dashboard/Views/MusicCategories/Edit.vue'
import Music from 'src/components/Dashboard/Views/Music.vue'
import CreateMusic from 'src/components/Dashboard/Views/Music/Create.vue'
import EditMusic from 'src/components/Dashboard/Views/Music/Edit.vue'
import Posts from 'src/components/Dashboard/Views/Posts.vue'
import EditPost from 'src/components/Dashboard/Views/Posts/Edit.vue'
import PostsCategories from 'src/components/Dashboard/Views/PostsCategories.vue'
import CreatePostsCategory from 'src/components/Dashboard/Views/PostsCategories/Create.vue'
import EditPostsCategory from 'src/components/Dashboard/Views/PostsCategories/Edit.vue'
import Auth from '../middleware/Auth'
import Viewer from "../middleware/Viewer";

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/',
        redirect: "/templates",
        component: DashboardLayout,
        children: [
            {
                path: 'categories',
                name: 'Categories',
                component: Categories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'categories/create',
                name: 'create-category',
                component: CreateCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'categories/:id',
                name: 'edit-category',
                component: EditCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'templates',
                name: 'Templates',
                component: Templates,
                meta: {
                    middleware: [Viewer]
                },
            },
            {
                path: 'templates/create',
                name: 'create-template',
                component: CreateTemplate,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'templates/:id',
                name: 'edit-template',
                component: EditTemplate,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'memories',
                name: 'Memories',
                component: Memories,
                meta: {
                    middleware: [Viewer]
                },
            },
            {
                path: 'memories/create',
                name: 'create-for-you',
                component: CreateMemories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'memories/:id',
                name: 'edit-for-you',
                component: EditMemories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tags',
                name: 'Tags',
                component: Tags,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tags/create',
                name: 'create-tag',
                component: CreateTag,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tags/:id',
                name: 'edit-tag',
                component: EditTag,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'preview',
                component: PreviewHub,
                children: [
                    {
                        path: '',
                        name: 'Preview',
                        redirect: {name: 'preview-templates'},
                    },
                    {
                        path: 'templates',
                        name: 'preview-templates',
                        component: Preview,
                        meta: {
                            middleware: [Viewer]
                        },
                    },
                    {
                        path: 'carousels',
                        name: 'preview-carousels',
                        component: PostsPreview,
                        props: {type: 'carousel'},
                        meta: {
                            middleware: [Auth]
                        },
                    },
                    {
                        path: 'stories',
                        name: 'preview-stories',
                        component: PostsPreview,
                        props: {type: 'stories'},
                        meta: {
                            middleware: [Auth]
                        },
                    },
                    {
                        path: 'frames',
                        name: 'preview-frames',
                        component: ResourcePreview,
                        props: {resource: 'frames', editRoute: 'edit-frame', emptyLabel: 'Нет фреймов'},
                        meta: {
                            middleware: [Auth]
                        },
                    },
                    {
                        path: 'graphics',
                        name: 'preview-graphics',
                        component: ResourcePreview,
                        props: {resource: 'graphics', editRoute: 'edit-graphic', emptyLabel: 'Нет стикеров'},
                        meta: {
                            middleware: [Auth]
                        },
                    },
                ]
            },
            {
                path: 'car-preview',
                redirect: {name: 'preview-carousels'},
            },
            {
                path: 'nola-preview',
                name: 'PreviewNola',
                component: PostsPreviewNola,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'albums',
                name: 'Albums',
                component: Albums,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'albums/create',
                name: 'create-album',
                component: CreateAlbum,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'albums/:id',
                name: 'edit-album',
                component: EditAlbum,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tracks',
                name: 'Tracks',
                component: Tracks,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tracks/create',
                name: 'create-track',
                component: CreateTrack,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tracks/:id',
                name: 'edit-track',
                component: EditTrack,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'reports',
                name: 'reports',
                component: Reports,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'reports/create',
                name: 'create-report',
                component: CreateReport,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'finance',
                name: 'finance',
                component: Finance,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'push-tasks',
                name: 'push-tasks',
                component: PushTask,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'push-tasks/create',
                name: 'create-push-tasks',
                component: CreatePushTask,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'finance/create',
                name: 'create-finance',
                component: CreateFinance,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'finance/:id',
                name: 'edit-finance',
                component: EditFinance,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'logs',
                name: 'logs',
                component: Logs,
                meta: {
                    middleware: [Viewer]
                },
            },
            {
                path: 'calendar',
                name: 'Calendar',
                component: Calendar,
                meta: {
                    middleware: [Viewer]
                },
            },
            {
                path: 'tabs',
                name: 'Tabs',
                component: Tabs,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tabs/create',
                name: 'create-tab',
                component: CreateTab,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'tabs/:id',
                name: 'edit-tab',
                component: EditTab,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'fonts',
                name: 'Fonts',
                component: Fonts,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'fonts/create',
                name: 'create-font',
                component: CreateFont,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'fonts/:id',
                name: 'edit-font',
                component: EditFont,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'font/categories',
                name: 'fonts-categories',
                component: FontsCategories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'font/categories/create',
                name: 'create-fonts-category',
                component: CreateFontsCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'font/categories/:id',
                name: 'edit-fonts-category',
                component: EditFontsCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'graphic/categories',
                name: 'graphics-categories',
                component: GraphicsCategories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'graphic/categories/create',
                name: 'create-graphics-category',
                component: CreateGraphicsCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'graphic/categories/:id',
                name: 'edit-graphics-category',
                component: EditGraphicsCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'graphics',
                name: 'graphics',
                component: Graphics,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'graphics/create',
                name: 'create-graphic',
                component: CreateGraphic,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'graphics/:id',
                name: 'edit-graphic',
                component: EditGraphic,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'frame/categories',
                name: 'frames-categories',
                component: FramesCategories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'frame/categories/create',
                name: 'create-frames-category',
                component: CreateFramesCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'frame/categories/:id',
                name: 'edit-frames-category',
                component: EditFramesCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'calc',
                name: 'calc',
                component: Calc,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'frames',
                name: 'frames',
                component: Frames,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'frames/create',
                name: 'create-frame',
                component: CreateFrame,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'frames/:id',
                name: 'edit-frame',
                component: EditFrame,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'effect/categories',
                name: 'effects-categories',
                component: EffectsCategories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'effect/categories/create',
                name: 'create-effects-category',
                component: CreateEffectsCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'effect/categories/:id',
                name: 'edit-effects-category',
                component: EditEffectsCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'effects',
                name: 'effects',
                component: Effects,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'effects/create',
                name: 'create-effect',
                component: CreateEffect,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'effects/:id',
                name: 'edit-effect',
                component: EditEffect,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'music/categories',
                name: 'music-categories',
                component: MusicCategories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'music/categories/create',
                name: 'create-music-category',
                component: CreateMusicCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'music/categories/:id',
                name: 'edit-music-category',
                component: EditMusicCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'new-music',
                name: 'music',
                component: Music,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'new-music/create',
                name: 'create-music',
                component: CreateMusic,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'new-music/:id',
                name: 'edit-music',
                component: EditMusic,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'posts',
                name: 'posts',
                component: Posts,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'posts/:id',
                name: 'edit-post',
                component: EditPost,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'post/categories',
                name: 'posts-categories',
                component: PostsCategories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'post/categories/create',
                name: 'create-posts-category',
                component: CreatePostsCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'post/categories/:id',
                name: 'edit-posts-category',
                component: EditPostsCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'icons',
                name: 'Icons',
                component: Icons,
                // meta: {
                //     middleware: [Auth]
                // },
            },

        ]
    },
    {path: '*', component: NotFound}
];

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js